module.exports = __webpack_public_path__ + "static/media/bullz_load.d320ed97.gif";